//selectedInvestmentForAppraisalslice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InvestmentForAppraisalModel } from "../../all_Interfaces";

export interface InvestmentNames {
    investmentId:string,
    name:string,
    funID:string,
    investmentType:string
  }

interface InitialState {
    data: InvestmentForAppraisalModel ,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as InvestmentForAppraisalModel,
    error: '',
    loading: false
}

const selectedInvestmentForAppraisal = createSlice({
    name: "selectedInvestmentForAppraisal",
    initialState,
    reducers: {
        updateSelectedInvestmentForAppraisal(state, action: PayloadAction<InvestmentForAppraisalModel>) {
            state.data = action.payload;
        },
    },
});

export const { updateSelectedInvestmentForAppraisal } = selectedInvestmentForAppraisal.actions;

export default selectedInvestmentForAppraisal.reducer;